import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs/Observable';
import { SERVER, LOGON_INFO } from "../app.constants";


@Injectable()
export class StatisticService {


    constructor(
        private _htc: HttpClient
    ) {  }


    //統計情報取得
    getStatistic(type: string, start_ymd: string, end_ymd: string): Observable<any> {
        return this._htc.get(SERVER.baseURL+'/get-statistic/'+LOGON_INFO.PARENT_COMP_ID+'/'+type+'/'+start_ymd+'/'+end_ymd+'/');
    }

}


// WEBPACK FOOTER //
// ./src/app/statistic/statistic.service.ts